<template>
    <div class="papercorrectionlist">
        <el-card class="search-form">
            <el-form label-position="left" label-width="130px" :model="form">
                <el-row>
                    <!-- <el-col :span="8">
                        <el-form-item>
                          <div slot="label" class="form-label">
                              试卷来源:
                          </div>
                          <el-select v-model="form.input1" clearable placeholder="请选择" class="my-select">
                              <el-option
                                v-for="item in sourceOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                          </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item>
                          <div slot="label" class="form-label">
                              试卷ID:
                          </div>
                          <el-input v-model="form.paper_id" placeholder="请输入" clearable @keyup.enter.native="search"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item>
                          <div slot="label" class="form-label">
                              练习册ID:
                          </div>
                          <el-input v-model="form.practice_id" placeholder="请输入" clearable @keyup.enter.native="search"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item>
                          <div slot="label" class="form-label">
                              作业名称:
                          </div>
                          <el-input v-model="form.exercise_name" placeholder="请输入" clearable @keyup.enter.native="search"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" >
                        <el-form-item>
                          <div slot="label" class="form-label">
                              学员手机号:
                          </div>
                          <el-input v-model="form.phone" placeholder="请输入" clearable @keyup.enter.native="search"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item>
                          <div slot="label" class="form-label">
                              批改人工号:
                          </div>
                          <el-input v-model="form.correct_user" placeholder="请输入" clearable @keyup.enter.native="search"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item>
                            <div slot="label" class="form-label">
                                批改完成时间:
                            </div>
                            <div style="width: 100%; display:flex; justify-content: space-between;">
                              <el-date-picker
                                style="flex: 0 0 45%"
                                :picker-options="pickerOptions_begin"
                                v-model="form.start_time"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="起始时间">
                              </el-date-picker>
                              <span>~</span>
                              <el-date-picker
                                style="flex: 0 0 45%"
                                :picker-options="pickerOptions_end"
                                v-model="form.end_time"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="终止时间">
                              </el-date-picker>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item>
                          <div slot="label" class="form-label">
                              作业记录ID:
                          </div>
                          <el-input v-model="form.record_id" placeholder="请输入" clearable @keyup.enter.native="search"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" :offset="8">
                        <div class="button-group">
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button @click="initForm">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-card class="box-card">
            <el-row>
                已提交 {{ pageInfo.total }} 份试卷
            </el-row>
            <el-table :data="paper_list">
                <el-table-column label="作业" width="180">
                    <template slot-scope="scope">
                      <el-tooltip placement="top" v-if="charLength(`【${scope.row.paper_id}】${scope.row.exercise_name}`) > 44">
                          <div slot="content" :style="{width: '180px'}">{{`【${scope.row.exercise_id}】${scope.row.exercise_name}`}}</div>
                          <div class="line-clamp">{{`【${scope.row.exercise_id}】${scope.row.exercise_name}`}}</div>
                      </el-tooltip>
                      <div v-else>
                        {{`【${scope.row.exercise_id}】${scope.row.exercise_name}`}}
                      </div>
                    </template>
                </el-table-column>
                <el-table-column label="作业记录ID">
                    <template slot-scope="scope">
                        {{ scope.row.record_id }}
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="学员信息">
                    <template slot-scope="scope">
                        <span v-show="scope.row.user_name">{{ scope.row.user_name }}<br></span>{{  scope.row.phone }}
                    </template>
                </el-table-column>
                <el-table-column label="提交时间">
                    <template slot-scope="scope">
                        {{ scope.row.submit_time }} <span v-if="is_overtime(scope.row.submit_limit_time, scope.row.submit_time)">[<span style="color:green;">准时</span>]</span><span v-else>[超时]</span>
                    </template>
                </el-table-column>
                <el-table-column prop="correct_over_time" label="批改完成时间">
                    <template slot-scope="scope">
                        {{ scope.row.release_time }}
                    </template>
                </el-table-column>
                <el-table-column prop="admin_info" label="批改人信息">
                    <template slot-scope="scope">
                        {{ scope.row.assign_correct_user |  adminInfo}}
                    </template>
                </el-table-column>
                <el-table-column label="试卷状态" width="120">
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_release == 0" @click="goStatus(scope.row);">待人工批改<br><span class="blue"><span class="el-icon-search"></span>去审核</span></span>
                        <span v-show="scope.row.is_release == 2" @click="goStatus(scope.row);">人工批改中<br><span class="blue"><span class="el-icon-s-promotion"></span>去发布</span></span>
                        <span v-show="scope.row.is_release == 1" @click="goStatus(scope.row);">人工批改完成<br><span class="blue">查看</span></span>
                    </template>
                </el-table-column>
            </el-table>


            <!-- 分页 -->
            <el-pagination class="paginationblock"
                layout="prev, pager, next, sizes, jumper"
                background
                :page-size="pageInfo.size"
                :page-sizes="[10, 20, 50, 100]"
                :total="pageInfo.total"
                :current-page="pageInfo.page"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "homeworklist",
        filters: {
            // 批改人信息
            adminInfo (value1) {
                if (!value1) {
                    return '无'
                }
                return `${value1}`;
            },
            // 作答用时格式化,以秒为单位
            timeFormat (value) {
                var time = value;
                var h = parseInt(time / 3600),
                    m = parseInt(time % 3600 / 60),
                    s = parseInt(time % 60);
                h = h < 10 ? "0"+ h : h;
                m = m < 10 ? "0"+ m : m;
                s = s < 10 ? "0"+ s : s;
                return `用时：${h}:${m}:${s}`;
            }
        },
        data() {
            return {
                // 搜索表单
                form: {},
                pageInfo: {
                    size: 10,
                    page: 1,
                    total: 0
                },
                paper_list:[]
            }
        },
        computed: {
          pickerOptions_begin () {
            console.log(this.form);
            var _this = this;
            if (_this.form.release_time_end) {
              return {
                disabledDate(time) {
                  return time.getTime() >= new Date(_this.form.release_time_end).getTime();
                }
              }
            }
            return {};

          },
          pickerOptions_end () {
            var _this = this;
            if (_this.form.release_time_begin) {
              return {
                disabledDate(time) {
                  return time.getTime() <= new Date(_this.form.release_time_begin).getTime();
                }
              }
            }
            return {};
          }
        },
        methods: {
            // 作答时间是否超时
            is_overtime (value1, value2) {
                // value1 截止时间，value2实际作答结束时间
                if (!value1 || value1 >= value2) {
                    return true;
                }
                return false;
            },
            //获取字符串的真实长度
            charLength (str) {
              var realLength = 0, len = str.length, charCode = -1;
              for (var i = 0; i < len; i++) {
                charCode = str.charCodeAt(i);
                if (charCode >= 0 && charCode <= 255) {
                  realLength += 1;
                } else {
                  realLength += 2;
                }
              }
              return realLength;
            },
            // 查询
            search () {
                console.log('search', this.form);
                this.pageInfo.page = 1;
                this.paperList();
            },
            // 重置
            initForm () {
                console.log('initForm');
                this.form = {};
                this.pageInfo.page = 1;
                this.paperList();
            },
            paperList () {
                var params = {...this.form, ...this.pageInfo};

                this.$api.GETEXERCISELIST(params).then((res) => {
                    if(res.retcode==0){
                        this.paper_list = res.data.list;
                        this.pageInfo.total = res.data.total;
                        console.log(this.paper_list)
                    }else{
                        this.$message.error(res.message);
                    }

                })
            },

            // 切换每页条目数
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageInfo.size = val;
                this.search();
            },

            // 当前页面page参数发生改变
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.pageInfo.page = val;
                this.paperList();
            },
            goStatus(record){
                const { homework_type, exercise_id, assign_correct_user, object_type, exercise_name , status, iip_paper_id, paper_id, record_id, is_release, tiku_user_id, sso_id, object_id, description, is_reject } = record;
                // 跳转
                if(assign_correct_user === '') {
                    return
                }
                const view = this.$router.resolve({
                    path: `/homework-info/${object_id}/${record_id}/${tiku_user_id}/${object_type}/${exercise_id}/${assign_correct_user}/${sso_id}/''/''/''/${is_release}/${is_reject}?homework_type=${homework_type}`
                })
                window.localStorage.setItem('name', `${exercise_name}`)
                window.localStorage.setItem('description', `${description}`);
                window.open(view.href, '_blank');
            }
        },
        created () {
            if (this.$route.params.pathMatch) {
              let arr = this.$route.params.pathMatch.split('/');
              this.form.sso_id = arr[0] || '';
              this.form.module_type = arr[1] || '';
              this.form.exer_id = arr[2] || '';
            }
            this.paperList();
            var bc = new BroadcastChannel('paper_list');
            bc.onmessage = (ev) => {
              if (ev.data == 'pageRefresh') {
                this.$router.go(0);
              }
            }
        }
    }
</script>

<style scoped lang="less">
    .el-date-editor.el-input{
        min-width: 134px;
    }
    .green-tip,.red-tip {
        display: inline-block;
        float: left;
        width: 5px;
        height: 5px;
        margin: 10px 10px 0 0;
        border-radius: 50%;
        background: green;
    }
    .red-tip {
        background: red;
    }
    .papercorrectionlist .has-gutter{
        background-color: #eee;
    }
    .search-form {
        background-color: #fff;
        padding-top: 22px;
        margin-bottom: 22px;
        .form-label {
            text-align: right;
            padding-right: 10px;
        }
        .my-select {
            width: 100%;
        }
        .button-group {
            display: flex;
            justify-content: flex-end;
        }
    }
    .paginationblock{
      padding: 20px 0;
      text-align: right;
      background-color: #fff;
    }
    .box-card {
        .line-clamp {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
    }
</style>
<style>
    .blue{
        color: #1890ff;
        cursor: pointer;
    }
    .papercorrectionlist .has-gutter tr{
        border: 1px solid #eee;
    }
    .papercorrectionlist .has-gutter tr th{
        background-color: #eee;
    }
</style>



// WEBPACK FOOTER //
// src/pages/homework-list/index.vue